import Handlebars from 'handlebars';

export const ServiceTypes = {
    TELLODY_VOUCHER: "voucher",
    TELLODY_SURVEY: "survey",
    EMAIL_OPTIN: "optin",
    QUIZ_OPTIN: "quiz",
    INSTANT_WIN: "instantWin",
    PAY_PAL_PAYMENT: "payPalPayment",
    BULK: "bulk",
    SMART_NOTIFICATION: "smartNotification"
};

export function serviceBalloonClass(serviceType, id) {
    if(serviceType === "bulk" || serviceType === "smartNotification") {
        return "bg-" + Handlebars.helpers.tilecolorclass(id);
    } else {
        let classPrefix = "";
        if (serviceType === "voucher")
            classPrefix="ribbed-";
        else if (serviceType === "survey")
            classPrefix="bbgg-";
        else
            classPrefix="bbbggg-";
        return classPrefix + Handlebars.helpers.tilecolorclass(id);
    }
}

export const Statuses = {
    "ACTIVE,NOT_STARTED": "active",
    "ENDED": "ended",
    "PENDING_APPROVAL": "draft"
}